import styled from 'styled-components';

export const CarregarDadosLabel = styled.p`
  margin: 10px 10px 20px 10px;
`;

export const NomeArquivo = styled.p`
  margin: 3px 0 3px 5px;
  color: #689ef8;
  cursor: pointer;
  padding-top: 3px;
`;

export const ApagarArquivo = styled.p`
  margin: 2px 0 3px 14px;
  color: #c62828;
  cursor: pointer;
  padding: 6px;
  font-size: 8pt;
`;
